import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// Full detail (including transcript) for one charting call — fetched lazily
// when a row in the "Charting calls" log is expanded.
export function useChartingRun(runId: string | null) {
  const query = useQuery({
    queryKey: payerKeys.chartingRun(runId ?? ''),
    queryFn: () => payersApi.getChartingRun(runId as string),
    enabled: !!runId,
  });
  return { run: query.data ?? null, isLoading: query.isLoading };
}
